import { connect } from 'react-redux'
import React, { Component } from 'react'
import { createAction } from 'redux-actions'
import { OrderedMap } from 'immutable'
import SearchIcon from 'react-icons/lib/fa/filter'
import SortIcon from 'react-icons/lib/md/sort'
import CloseIcon from 'react-icons/lib/md/close'
import { browserHistory, Link } from 'react-router'
import {
  DESELECT_ALL,
  deleteSelectedVideos,
} from '../../actions'
import { Modal, ModalFooter, ModalBody } from '../../misc/modals'

const mapStateToProps = (state, ownProps) => {
  const { me, videos } = state
  return {
    ...ownProps,
    selected: me.selected.toArray(),
    videos,
    me,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  deselectAll: () => {
    dispatch(createAction(DESELECT_ALL)())
  },
  deleteSelectedVideos: () => {
    dispatch(deleteSelectedVideos())
    .then(() => dispatch(createAction(DESELECT_ALL)()))
  },
})

class VideosListHeader extends Component {
  constructor() {
    super()
    this.state = {
      deleteModalOpen: false,
      selectedVideos: new OrderedMap(),
    }
    this.setState = this.setState.bind(this)
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this)
    this.videosSelected = this.videosSelected.bind(this)
    this.onSort = this.onSort.bind(this)
    this.onSearch = this.onSearch.bind(this)
  }

  toggleDeleteModal() {
    this.setState({
      deleteModalOpen: !this.state.deleteModalOpen,
    })
  }

  videosSelected(videos) {
    this.setState({ selectedVideos: videos })
  }

  onSearch(e) {
    this.props.onSearchChanged(e.target.value)
  }

  onSort(e) {
    if (e.target.value == 'shortcode' || e.target.value == 'title') {
      this.props.onSortChanged(e.target.value, 'ASC')
      return
    }
    this.props.onSortChanged(e.target.value, 'DESC')
  }

  onTagChange(e) {
    if (!e.target.value.length) {
      browserHistory.push("/")
      return
    }
    browserHistory.push(`/tag/${encodeURIComponent(e.target.value)}`)
  }

  render() {

    const showSearchButton = !this.state.searchSelected && (!this.props.search || !this.props.search.length)
    return (
      <div className="video-list-header">
        <Modal
          isOpen={this.state.deleteModalOpen}
          toggle={this.toggleDeleteModal}
          title="Delete Video"
          className="app-modal"
        >
          <ModalBody>Are you sure you want to delete {this.props.selected.length} video{this.props.selected.length === 1 ? '' : 's'}?</ModalBody>
          <ModalFooter>
            <button
              className="blue-button" onClick={(e) => {
                this.toggleDeleteModal()
                this.props.deleteSelectedVideos()
                this.setState({ selectedVideos: this.state.selectedVideos.clear() })
              }}
            >Delete</button>
          </ModalFooter>
        </Modal>
        {this.props.selected.length === 0
        ?
          <div className="video-list-metadata">
            {this.props.group ? '' :
            
            <div className="sort-control">
              <SortIcon />
              <select 
                value={this.props.sort}
                type="select"
                size="1"
                name="sort"
                ref="sort"
                className="sort-input form-control"
                onChange={this.onSort}
              >
                <option value="date_added">Newest</option>
                <option value="plays">Popular</option>
                <option value="title">A to Z</option>
              </select>
            </div>
            }
            <div className="search-control float-right hidden-down">
              <span className="search-text">
                <b><SearchIcon /></b>
                {showSearchButton ? <span><b>Filter</b> by title</span> : '' }
              </span>
              <input
                type="text"
                value={this.props.search || ''}
                className="form-control filter-input"
                placeholder={this.state.searchSelected ? 'Enter title' : ''}
                ref="filter"
                onChange={this.onSearch}
                onBlur={e => this.setState({searchSelected: false})}
                onFocus={e => this.setState({searchSelected: true})}
              />
            </div>
          </div>
        :
          <div className="video-list-actions">
            <button
              className="float-right close-action video-list-action"
              onClick={(e) => {
                e.preventDefault()
                this.props.deselectAll()
              }}
            ><CloseIcon /></button>
            <Link
              className="video-list-action"
              onClick={(e) => {
                e.preventDefault()
                this.toggleDeleteModal()
              }}
              to="/"
            >
              Delete {this.props.selected.length} video{this.props.selected.length === 1 ? '' : 's'}
            </Link>
            {this.props.selected.length > 1 ?
              <Link
                className="video-list-action"
                to="/joiner"
              >
                Join {this.props.selected.length} video{this.props.selected.length === 1 ? '' : 's'}
              </Link>
            : ''}
          </div>
        }
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideosListHeader)
